import { apiFetch } from './client';

export interface OverageRates {
  extra_channel_cents: number;
  extra_minute_cents: number;
  extra_storage_gb_cents: number;
  extra_did_cents: number;
}

export interface PlanRow {
  id: string;
  reseller_id: string | null;
  name: string;
  monthly_price_cents: number;
  included_channels: number;
  included_storage_gb: number;
  included_minutes: number;
  included_active_dids: number;
  overage_rates: OverageRates;
  enabled_modules: string[];
  stripe_price_id: string | null;
  active: boolean;
  created_at: string;
  updated_at: string;
}

export interface CreatePlanInput {
  name: string;
  monthly_price_cents: number;
  included_channels: number;
  included_storage_gb: number;
  included_minutes: number;
  included_active_dids: number;
  overage_rates: OverageRates;
  enabled_modules: string[];
  stripe_price_id?: string | null;
}

export const plans = {
  list: (includeInactive = false) =>
    apiFetch<{ rows: PlanRow[] }>(`/api/plans${includeInactive ? '?includeInactive=true' : ''}`),

  get: (id: string) => apiFetch<PlanRow>(`/api/plans/${id}`),

  create: (input: CreatePlanInput) =>
    apiFetch<PlanRow>('/api/plans', {
      method: 'POST',
      body: JSON.stringify(input),
    }),

  update: (id: string, input: Partial<CreatePlanInput> & { active?: boolean }) =>
    apiFetch<PlanRow>(`/api/plans/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(input),
    }),

  delete: (id: string) =>
    apiFetch<void>(`/api/plans/${id}`, { method: 'DELETE' }),
};
